import React, {useEffect} from "react";
import {Stack, Skeleton, Box, Paper, useTheme, alpha} from "@mui/material";
import CustomButton from "../../../core/components/ui/CustomButton";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useNavigate, useLocation} from "react-router-dom";
import usePort from "../hooks/usePort";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";

const ViewPortComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const {isViewingPort, portDetails, viewPort} = usePort();
    const portId = new URLSearchParams(location.search).get('id');
    

    useEffect(() => {
        const parameters = {portUID: portId};

        viewPort(parameters);
    }, [portId]);


    const handleBack = () => {
        navigate("/ports"); 
    }


    return (
        <>  
            <CustomButton 
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Port List"
                customStyles={{fontSize: 14, ml: -2}}
                onClick={handleBack}
            />

            <Box sx={{textAlign: "start", mt: 2}}>
                <CustomTypography 
                    variant="h3"
                    text={"Port Details"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"View and manage port information"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Stack direction={{xs: "column", md: "row"}} spacing={4}>
                    <Stack spacing={2} flex={1}>
                        <Box>
                            <CustomTypography 
                                variant="caption" 
                                text={"Port Name"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.port_name || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                        <Box sx={{display: "inline-grid"}}> 
                            <CustomTypography 
                                variant="caption" 
                                text={"Type"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.type || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                        <Box sx={{display: "inline-grid"}}> 
                            <CustomTypography 
                                variant="caption" 
                                text={"Location"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.location || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                    </Stack>

                    <Stack spacing={2} flex={1}>
                        <Box>
                            <CustomTypography 
                                variant="caption" 
                                text={"Latitude"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.latitude || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                        <Box>
                            <CustomTypography 
                                variant="caption" 
                                text={"Longitude"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.longitude || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                        <Box sx={{display: "inline-grid"}}> 
                            <CustomTypography 
                                variant="caption" 
                                text={"Description"} 
                                customStyles={{
                                    marginBottom: 0, 
                                }}
                            />

                            {(isViewingPort) ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                                <CustomTypography
                                    variant="body1"
                                    text={(portDetails?.description || "N / A")}
                                    customStyles={{
                                        marginBottom: 0, 
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        </Box>
                    </Stack>

                    <Stack spacing={2} flex={1}>
                            <Box sx={{display: "inline-grid"}}>
                                <CustomTypography 
                                    variant="caption" 
                                    text={"Status"} 
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                {(isViewingPort) ?
                                    <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                                :
                                    <CustomChipComponent category="portStatus"
                                        label={(portDetails?.status === "Active") ? "Active" 
                                            : 
                                                (portDetails?.status === "Deactivated") ? "Deactivated"
                                            :
                                                portDetails?.status
                                        }
                                    />
                                }
                            </Box>
                        </Stack>
                </Stack>           
            </Paper>
       </>
    )
}

export default ViewPortComponent